<template>
  <CSFooter>
    <CSToolbar>
      <div class="row full-width">
        <div>Help A Family</div>
        <q-space />
        <div>&copy; {{ year }}</div>
      </div>
    </CSToolbar>
  </CSFooter>
</template>

<script setup lang="ts">
import CSToolbar from "@/components/CharitySystem/CSToolbar.vue";
import CSFooter from "@/components/CharitySystem/CSFooter.vue";

const year = new Date().getFullYear();
</script>
